import type { ReactElement } from 'react';
import { FilterTypes } from 'shared/types/analytics';
import { CheckboxControl } from '../checkboxControl';
import { DaterangeControl } from '../daterangeControl';
import {
  toCheckboxFilterValue,
  toDateRangeFilterValue,
  toMultiselectFilterValue,
  toRadioFilterValue,
  toSegmentsFilterValue,
  toSelectFilterValue,
} from '../filterControlValueGuards';
import { MultiselectControl } from '../multiselectControl';
import { RadioControl } from '../radioControl';
import { SegmentsControl } from '../segmentsControl';
import { SelectControl } from '../selectControl';
import type { FilterControlElementProps } from '../types';

export function FilterControlElement({
  type,
  filter,
  localSetter,
  localValue,
  disabled,
  openOnMount,
}: FilterControlElementProps): ReactElement {
  switch (type) {
    case FilterTypes.radio:
      return (
        <RadioControl
          filter={filter}
          localSetter={localSetter}
          localValue={toRadioFilterValue(localValue)}
          disabled={disabled}
        />
      );
    case FilterTypes.checkbox:
      return (
        <CheckboxControl
          filter={filter}
          localSetter={localSetter}
          localValue={toCheckboxFilterValue(localValue)}
          disabled={disabled}
        />
      );
    case FilterTypes.multiselect:
      return (
        <MultiselectControl
          filter={filter}
          localSetter={localSetter}
          localValue={toMultiselectFilterValue(localValue)}
          disabled={disabled}
          openOnMount={openOnMount}
        />
      );
    case FilterTypes.daterange:
      return (
        <DaterangeControl
          filter={filter}
          localSetter={localSetter}
          localValue={toDateRangeFilterValue(localValue)}
          disabled={disabled}
        />
      );
    case FilterTypes.select:
      return (
        <SelectControl
          filter={filter}
          localSetter={localSetter}
          localValue={toSelectFilterValue(localValue)}
          disabled={disabled}
        />
      );
    case FilterTypes.segments:
      return (
        <SegmentsControl
          filter={filter}
          localSetter={localSetter}
          localValue={toSegmentsFilterValue(localValue)}
          disabled={disabled}
        />
      );
    default: {
      const exhaustiveCheck: never = type;
      return exhaustiveCheck;
    }
  }
}
